import { useRecoilState } from "recoil"
import { sidebarTimelineState } from "../StateSelectors"
import { userFullName } from "../UserRow"
import { getActivityDetails } from "./util"
import { useTranslation } from "react-i18next"
import { TASKS_CHUNK_SIZE, scrollElementId } from "../TasksDisplaySidebar"
import { TimelineTasksDisplaySidebar } from "./TimelineTaskDisplaySidebar"

const TimelineSidebar = () => {
  const [sidebar, setSidebar] = useRecoilState(sidebarTimelineState)

  const activity = sidebar?.activity
  const users = sidebar?.users
  const quadriProjectId = sidebar?.quadriProjectId
  const user = users && activity ? users[activity.userId] : undefined
  const { t } = useTranslation("timeline")
  let activityIds: number[] | undefined
  if (activity?.activityId) {
    activityIds = [parseInt(activity.activityId)]
  } else {
    activityIds = []
  }
  const activityType = activity?.type

  return (
    <div className="panel">
      <header>
        <div className="panel-title">
          <h3>{t("sidebar.activityDetails")}</h3>
        </div>
        <button className="button icon-circle icon-medium tertiary" onClick={() => setSidebar(null)}>
          <i className="icon-font tc-icon-content-close" />
        </button>
      </header>
      <section id={scrollElementId}>
        <div className="panel-body">
          <div className="sub-section">
            <div className="section-header">
              <h5>{activity && getActivityDetails(activity)}</h5>
            </div>
            <div className="section-details pb-1">
              {activity?.worksetName && (
                <div className="label-group">
                  <label>{t("sidebar.workset")}</label>
                  <div className="value">{activity?.worksetName}</div>
                </div>
              )}
              {user && (
                <div className="label-group">
                  <label>{t("sidebar.user")}</label>
                  <div className="value">{userFullName(user)}</div>
                </div>
              )}
            </div>
          </div>
          {quadriProjectId && activity ? (
            <div className="sub-section">
              <div className="section-header"></div>
              <TimelineTasksDisplaySidebar
                nTasksTotal={activity.tasksAffectedCount ? activity.tasksAffectedCount : 0}
                quadriProjectId={quadriProjectId}
                activityType={activityType}
                activityIds={activityIds}
                fetchCount={TASKS_CHUNK_SIZE}
              />
            </div>
          ) : (
            <div className="sub-section">
              <div className="section-header" />
            </div>
          )}
        </div>
      </section>
    </div>
  )
}

export default TimelineSidebar
